import { apiClient } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';

const fetcher = async <T>(url: string): Promise<T> => {
  const response = await apiClient.get<T>(url);
  return response.data;
};

export const listQueryKey = (endpoint: string, key: string = 'list') => [key, endpoint] as const;

export function useList<T>(endpoint: string, shouldFetch: boolean = false, key: string = 'list') {
  const { data, error, isLoading } = useQuery<T>({
    queryKey: listQueryKey(endpoint, key),
    queryFn: () => fetcher<T>(endpoint),
    enabled: shouldFetch,
    retry: 3,
  });

  return {
    data,
    error,
    isLoading,
  };
}